"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Header = exports.Cell = exports.Row = exports.Rows = exports.ActionButton = exports.Toolbar = exports.List = void 0;
var react_1 = __importDefault(require("react"));
var ramda_1 = require("ramda");
require("./List.css");
var List = function (_a) {
    var children = _a.children, restProps = __rest(_a, ["children"]);
    return (react_1["default"].createElement("div", __assign({}, restProps), children));
};
exports.List = List;
var Toolbar = function (_a) {
    var title = _a.title, children = _a.children, restProps = __rest(_a, ["title", "children"]);
    return (react_1["default"].createElement("div", __assign({}, restProps, { className: "vs-list-toolbar vs-toolbar-widget-header" }),
        title && react_1["default"].createElement("span", { className: "vs-list-toolbar-title" }, title),
        children));
};
exports.Toolbar = Toolbar;
var ActionButton = function (_a) {
    var icon = _a.icon, _b = _a.className, className = _b === void 0 ? '' : _b, onClick = _a.onClick, restProps = __rest(_a, ["icon", "className", "onClick"]);
    return (react_1["default"].createElement("span", __assign({}, restProps, { className: "".concat(icon, " ").concat(className), onClick: onClick })));
};
exports.ActionButton = ActionButton;
var Rows = function (_a) {
    var children = _a.children, restProps = __rest(_a, ["children"]);
    return (react_1["default"].createElement("div", __assign({ className: "vs-list-rows" }, restProps), children));
};
exports.Rows = Rows;
var ExpandedRowPanel = function (_a) {
    var children = _a.children, restProps = __rest(_a, ["children"]);
    return (react_1["default"].createElement("div", __assign({}, restProps, { className: "vs-list-row-expanded" }), children));
};
var Row = function (props) { return (react_1["default"].createElement("div", __assign({ className: "vs-list-row" }, (0, ramda_1.omit)(['children', 'expansion'], props)),
    react_1["default"].createElement("div", { className: "container-fluid" },
        react_1["default"].createElement("div", { className: "row" }, props.children),
        props.expansion && (react_1["default"].createElement(ExpandedRowPanel, null, props.expansion))))); };
exports.Row = Row;
var Cell = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 1 : _b, children = _a.children, restProps = __rest(_a, ["width", "children"]);
    return (react_1["default"].createElement("div", __assign({}, restProps, { className: "vs-list-cell col-xs-".concat(width) }), children));
};
exports.Cell = Cell;
var renderHeaderCell = function (_a) {
    var width = _a.width, _b = _a.alignment, alignment = _b === void 0 ? 'left' : _b, text = _a.text, restProps = __rest(_a, ["width", "alignment", "text"]);
    return (react_1["default"].createElement(exports.Cell, __assign({}, restProps, { key: text, width: width }),
        react_1["default"].createElement("div", { className: "vs-list-header-label text-".concat(alignment) }, text)));
};
var Header = function (_a) {
    var labels = _a.labels, restProps = __rest(_a, ["labels"]);
    return (react_1["default"].createElement("div", __assign({ className: "vs-list-header" }, restProps),
        react_1["default"].createElement(exports.Row, null, (0, ramda_1.map)(renderHeaderCell, labels))));
};
exports.Header = Header;
